import { render, staticRenderFns } from "./UiIcon.vue?vue&type=template&id=f618e924"
import script from "./UiIcon.vue?vue&type=script&lang=js"
export * from "./UiIcon.vue?vue&type=script&lang=js"
import style0 from "./UiIcon.vue?vue&type=style&index=0&id=f618e924&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports